import React from "react";
import Chart, {
  BarController,
  LinearScale,
  BarElement,
  TimeScale,
  Tooltip,
} from "chart.js/auto";
import "chartjs-adapter-date-fns";
import { ReactChart } from "chartjs-react";
import { enUS } from "date-fns/locale";

const ChartPage = () => {
  // Register modules,
  // this example for time scale and linear scale
  ReactChart.register(
    BarController,
    LinearScale,
    BarElement,
    TimeScale,
    Tooltip
  );

  // options of chart similar to v2 with a few changes
  // https://www.chartjs.org/docs/next/getting-started/v3-migration/
  const chartOption = {
    scales: {
      x: {
        type: "time",
        adapters: {
          date: enUS,
        },
      },
      y: {
        type: "linear",
      },
    },
  };

  // data of chart similar to v2, check the migration guide
  const chartData = {};

  const chartjsStyles = {
    position: "relative",
    height: "344px",
  };
  const chartjsEarningsOptions = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            suggestedMax: 3000,
          },
        },
      ],
    },
    tooltips: {
      intersect: false,
      callbacks: {
        label: (tooltipItems) => {
          return " Rs " + tooltipItems.yLabel;
        },
      },
    },
  };
  const chartjsSalesOptions = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            suggestedMax: 260,
          },
        },
      ],
    },
    tooltips: {
      intersect: false,
      callbacks: {
        label: (tooltipItems) => {
          return " " + tooltipItems.yLabel + " Sales";
        },
      },
    },
  };
  const chartjsEarningsData = {
    labels: [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ],
    datasets: [
      {
        label: "This Year",
        fill: true,
        backgroundColor: "rgba(132, 94, 247, .3)",
        borderColor: "transparent",
        pointBackgroundColor: "rgba(132, 94, 247, 1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(132, 94, 247, 1)",
        data: [],
      },
      {
        label: "Last Year",
        fill: true,
        backgroundColor: "rgba(233, 236, 239, 1)",
        borderColor: "transparent",
        pointBackgroundColor: "rgba(233, 236, 239, 1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(233, 236, 239, 1)",
        data: [],
      },
    ],
  };
  const chartjsSalesData = {
    labels: [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ],
    datasets: [
      {
        label: "This Year",
        fill: true,
        backgroundColor: "rgba(34, 184, 207, .3)",
        borderColor: "transparent",
        pointBackgroundColor: "rgba(34, 184, 207, 1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(34, 184, 207, 1)",
        data: [],
      },
      {
        label: "Last Year",
        fill: true,
        backgroundColor: "rgba(233, 236, 239, 1)",
        borderColor: "transparent",
        pointBackgroundColor: "rgba(233, 236, 239, 1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(233, 236, 239, 1)",
        data: [],
      },
    ],
  };
  const latestCustomers = [
    {
      id: 1521,
      avatar: "avatar11",
      name: "Adam McCoy",
      orders: 5,
    },
    {
      id: 1520,
      avatar: "avatar1",
      name: "Betty Kelley",
      orders: 7,
    },
    {
      id: 1519,
      avatar: "avatar5",
      name: "Jesse Fisher",
      orders: 12,
    },
    {
      id: 1518,
      avatar: "avatar12",
      name: "Ryan Flores",
      orders: 19,
    },
    {
      id: 1517,
      avatar: "avatar3",
      name: "Alice Moore",
      orders: 2,
    },
    {
      id: 1516,
      avatar: "avatar13",
      name: "Scott Young",
      orders: 5,
    },
    {
      id: 1515,
      avatar: "avatar14",
      name: "Ralph Murray",
      orders: 9,
    },
  ];
  const latestOrders = [
    {
      id: 7835,
      date: "today",
      state: "Pending..",
      stateVariant: "warning",
      total: "$999,99",
    },
    {
      id: 7834,
      date: "today",
      state: "Pending..",
      stateVariant: "warning",
      total: "$2.299,00",
    },
    {
      id: 7833,
      date: "today",
      state: "Success",
      stateVariant: "success",
      total: "$1200,00",
    },
    {
      id: 7832,
      date: "today",
      state: "Cancelled",
      stateVariant: "danger",
      total: "$399,00",
    },
    {
      id: 7831,
      date: "today",
      state: "Success",
      stateVariant: "success",
      total: "$349,00",
    },
    {
      id: 7830,
      date: "today",
      state: "Success",
      stateVariant: "success",
      total: "$999,00",
    },
    {
      id: 7829,
      date: "today",
      state: "Success",
      stateVariant: "success",
      total: "$39,99",
    },
    {
      id: 7828,
      date: "today",
      state: "Success",
      stateVariant: "success",
      total: "$499,00",
    },
    {
      id: 7827,
      date: "today",
      state: "Success",
      stateVariant: "success",
      total: "$325,00",
    },
  ];

  return (
    <div>
      {" "}
      <ReactChart
        type="line"
        data={chartjsSalesData}
        options={chartjsSalesOptions}
        styles={chartjsStyles}
        height={400}
      />
    </div>
  );
};

export default ChartPage;
